<template>
    <b-card :header-bg-variant="hasOverrides" body-class="p-0" header-class="py-2">
        <template v-slot:header>
            <b-form-row>
                <b-col>
                    <span class="font-weight-bold">{{ title | titleCase }}</span>
                    <i v-if="hasOverrides == 'secondary' " class="ml-1 fa-regular fa-star text-primary"></i>
                </b-col>
                <b-col cols="5" class="text-right">
                    <b-button class="ml-2 text-dark font-dark" size="sm"
                              :disabled="isEditing"
                              @click="isEditing = !isEditing"
                              variant="outline-secondary"><i class="fa-light fa-edit"></i>
                    </b-button>
                </b-col>
            </b-form-row>
        </template>

        <template v-if="!isEditing">

            <!--view table-->
            <b-table small
                     bordered
                     head-variant="light"
                     class="text-center mb-0"
                     :items="item"
                     :fields="['level', 'max_dwt', 'percentage', 'description']">
                <template v-slot:cell(level)="data">
                    <span class="text-center">{{ data.index + 1 }}</span>
                </template>
                <template v-slot:cell(max_dwt)="data">
                    {{ data.item.max_dwt }}
                </template>
                <template v-slot:cell(percentage)="data">
                    {{ data.item.amount }}
                </template>
                <template v-slot:cell(description)="data">
                    {{ data.item.description }}
                </template>
            </b-table>
        </template>

        <!-- EDITS -->
        <template v-else>

            <!--add tier-->
            <b-card class="mb-3" body-class="p-2" bg-variant="light">
                <b-form-row>
                    <b-col cols="2">
                        <label for="" class="mb-1">Level</label>
                        <b-input  v-model="level" size="sm"></b-input>
                    </b-col>
                    <b-col cols="3">
                        <label for="" class="mb-1">Max Dwt</label>
                        <b-input v-model="max_dwt" size="sm"></b-input>
                    </b-col>
                    <b-col cols="2">
                        <label for="" class="mb-1">Percentage</label>
                        <b-input v-model="percentage" size="sm"></b-input>
                    </b-col>
                    <b-col>
                        <label for="" class="mb-1">Description</label>
                        <div class="d-flex align-items-center">
                            <b-input v-model="description" size="sm"></b-input>
                            <b-button size="sm"
                                      class="ml-1"
                                      @click="addTier"
                                      variant="success">
                                <i class="fa-regular fa-plus"></i>
                            </b-button>
                        </div>
                    </b-col>
                </b-form-row>
            </b-card>


            <!--edit table-->
            <b-table small
                     class="text-center"
                     :items="item"
                     :fields="['level', 'max_dwt', 'percentage', 'description']">
                <template v-slot:cell(level)="data">
                    <span class="text-center">{{ data.index + 1 }}</span>
                </template>
                <template v-slot:cell(max_dwt)="data">
                    <b-input @focus="$event.target.select()" size="sm" v-model="data.item.max_dwt"></b-input>
                </template>
                <template v-slot:cell(percentage)="data">
                    <b-input @focus="$event.target.select()" size="sm" v-model="data.item.amount"></b-input>
                </template>
                <template v-slot:cell(description)="data">
                    <div class="d-flex align-items-center">
                        <b-input @focus="$event.target.select()" size="sm" v-model="data.item.description"></b-input>

                        <i  v-if="data.item.item_category_id == null && item.length > 1"
                            v-b-tooltip.hover
                            title="Delete Tier"
                            @click="deleteTableTier(data)"
                            class="mx-2 pointer fa-regular fa-times text-danger"></i>

                        <i v-if="data.item.item_category_id != null"
                           v-b-tooltip.hover
                           title="Delete Level"
                           @click="deleteTableTier(data)"
                           class="mx-2 pointer fa-regular fa-times text-danger">
                        </i>
                    </div>
                </template>
            </b-table>


            <!-- save/cancel -->
            <b-card body-class="mb-0 p-2" class="mb-0" bg-variant="light">
                <div class="text-right">
                    <b-button size="sm"
                              v-b-tooltip.hover
                              title="Cancel all deletes, edits or additions"
                              variant="secondary"
                              @click="cancelTableEdits(item.name)">Cancel <i class="ml-1 fa-regular fa-times"></i>
                    </b-button>
                    <b-button size="sm"
                              variant="success"
                              class="ml-2"
                              v-b-tooltip.hover
                              title="Save deletes, edits or additions"
                              @click="saveTableEdits()">Save
                        <i v-if="!isSaving" class="ml-1 fa-regular fa-check"></i>
                        <i v-else class="fa-regular fa-spin fa-spinner" ></i>
                    </b-button>
                </div>
            </b-card>


        </template>


    </b-card>
</template>

<script>
    export default {
        name: 'rates-table',
        props: ['item', 'title', 'name', 'index', 'metal', 'hasOverrides', 'saving',],
        data() {
            return {
                isEditing: false,
                isSaving: false,
                level: null,
                max_dwt: null,
                percentage: null,
                description: null,
            }
        },
        watch: {
            saving(val) {
                console.log('fired');
                if(!val) {
                    this.isSaving = false;
                    this.isEditing = false;
                }
            }
        },
        methods: {
            deleteTableTier(item) {
//                console.log(item);
                this.$emit('openDeletedTier', item, this.title);
            },
            cancelTableEdits() {
                this.$emit('cancelEdits');
//                this.$nextTick(() => {
//                    this.isEditing = false
//                })
            },
            addTier() {
                let payload = {
                    level: this.level,
                    max_dwt: this.max_dwt,
                    amount: this.percentage,
                    amount_type:'%',
                    id: null,
                    name: this.item[0].name,
                    brand_id: null,
                    description: this.description,
                    item_type_id: this.item[0].item_type_id,
                    item_class_id: this.item[0].item_class_id,
                    item_category_id: this.item[0].item_category_id,
                }
                this.$emit('addTier', payload, this.title, this.name, this.metal);
                this.level = null;
                this.max_dwt = null;
                this.percentage = null;
                this.description = null;
            },
            saveTableEdits() {
                this.isSaving = true;
                this.$emit('saveEdits');
            }
        }


    };
</script>

<style scoped>

</style>
